import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import busTotal from '@/components/BusTotal'
import DriverTotal from '@/components/DriverTotal'
import OrderList from '@/components/OrderList'
import Login from '@/components/Login'

import AdminToken from "@/common/AdminToken"
import Storage from "../utils/Storage";
import BusTotal from "../components/BusTotal";

Vue.use(Router)
import { Dialog } from 'vant';


var router = new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'index',
            component: Index
        },
        {
            path: "/busTotal",
            name: "busTotal",
            component: BusTotal
        },
        {
            path: "/driverTotal",
            name: "driverTotal",
            component: DriverTotal
        },
        {
            path: "/orderList",
            name: "orderList",
            component: OrderList
        },{
            path: "/login",
            name: "login",
            component: Login
        }
    ]
})

router.beforeEach((to, from, next) =>{

    var adminToken = (new AdminToken).getToken();
    if(!adminToken){
        Dialog({
            message: "登陆已过期",
        });
    }

    if(adminToken || to.path === "/login" || to.path === "/error" ){
        next();
        return;
    }


    var storage = new Storage();
    storage.set("before_path", to.fullPath);

    next({path: '/login'});
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js